<script setup lang="ts">
  import { type CustomElement, JsonEditor } from '@logistiek-zonder-papier/lzp-library'
  import ConnectionCheck from '@/components/form-wizard/ConnectionCheck.vue'
  import FlowPathInput from '@/components/form/FlowPathInput.vue'

  const field = defineModel<CustomElement>({ required: true })
</script>

<template>
  <div class="config-fields">
    <FlowPathInput label="Label" v-model="field.label" :optional="true" :validate-paths="true" />
    <ConnectionCheck v-if="field.customType === 'wsbd'" v-model="field" />
    <JsonEditor v-model="field.json" label="JSON" :collapsed="true" />
    <JsonEditor v-model="field.jsonSchema" label="JSON Schema" :collapsed="true" />
  </div>
</template>

<style scoped lang="css">
  .config-fields {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
</style>
